import initWebsocket from './init-websocket';
import ModalRecaptcha from '../shared/modal-recaptcha/index.js';
import cookie from "cookie";

import {v4 as uuidv4} from 'uuid';

Vue.use(ModalRecaptcha);

export default {
    mixins  : [
        initWebsocket,
    ],
    data    : function () {
        return {
            taskId          : null,
            downloadUrl     : null,
            images          : [],
            downloadFiles   : [],
            downloadFileInfo: {
                name    : null,
                sitename: 'Techjunkie Tools'
            },

            dropboxFiles: [],

            sended             : false,
            completed          : false,
            processing         : false,
            interval           : null,
            progress           : null,
            state              : null,
            sendError          : null,
            sendErrorCode      : null,
            cancelToken        : null,
            websocketProcessing: false,
            websocketId        : uuidv4(),
            existWsListener    : false,

            needCaptcha: true,

            taskUrl: '/pdf/prepare',
        }
    },
    computed: {
        isEnabledWebsockets() {
            return this.websocketProcessing && this.websocketAvailable();
        }
    },
    methods : {
        prepareTaskData() {
            // you should override this if needed
            return {};
        },

        sendTask() {
            let data = this.prepareTaskData();
            data.is_ws = this.isEnabledWebsockets;
            data.ws_id = this.websocketId;

            if (window.Laravel.loadProd && this.needCaptcha && (((typeof window.stripe !== "undefined") && !!!window.stripe.ha) || (typeof window.stripe === "undefined"))) {
                this.$modalRecaptcha.open()
                    .then((response) => {
                        if (response.status == 'verify') {
                            data.recaptcha_response = window.Laravel.cT + ':' + response.token;
                            this._sendTask(data);
                        } else if (this.showLoading) {
                            this.showLoading = false;
                        }
                    });
            } else {
                this._sendTask(data);
            }

        },

        _sendTask(data) {
            if (this.sended) {
                return false;
            }

            if (this.isEnabledWebsockets) {
                this.initWebsocket();
            }

            const CancelToken = axios.CancelToken;
            this.cancelToken = CancelToken.source();

            this.sended = true;

            axios({
                cancelToken: this.cancelToken.token,
                method     : 'POST',
                url        : this.taskUrl,
                data       : data,
            }).then(response => {
                this.onSuccessSend(response);
                this.successSendProcessing(response);
                this.onAfterSuccessSendProcessing(response);
            }).catch(error => {
                if (axios.isCancel(error)) {
                    this.onCanceledSend();
                    this.canceledSendProcessing();
                } else {
                    this.onErrorSend(error);
                    this.errorSendProcessing(error);
                }
            });
        },

        onSuccessSend(response) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        onAfterSuccessSendProcessing(response) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        onErrorSend(error) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        onCanceledSend(error) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        successSendProcessing(response) {
            let result = response.data;

            if (this.isEnabledWebsockets) {
                this.taskId = result.task_id;
                this.completed = false;
                this.processing = true;

                if (!this.existWsListener) {
                    let channelName = 'tool-status-' + this.websocketId;

                    window.Echo.channel(channelName)
                        .listen('RealTimeMessage', (e) => {

                            let resultQueue = {
                                data: e.resultData
                            };
                            if (!resultQueue.data.status) {
                                let errorObj = {
                                    response: resultQueue
                                };
                                this.errorProcessing(errorObj);
                            } else {
                                this._successProcessingActions(resultQueue);
                            }
                        });
                    this.existWsListener = true;
                }
            } else if (result.queue) {
                this.taskId = result.task_id;
                this.completed = false;
                this.processing = true;

                this.startCheckingProcessing(response);
            } else {
                this.processing = false;
                this.taskId = result.task_id;
                this.downloadUrl = result.download_url;
                this.images = result.images;
                this.downloadFiles = result.files;
                if (result.download_url) {
                    this.downloadFileInfo.name = result.download_url.replace(/^.*[\\\/]/, '');
                    this.dropboxFiles = [
                        {
                            'url'     : result.download_url,
                            'filename': result.download_url.replace(/^.*[\\\/]/, ''),
                            'task_id' : result.task_id,
                        }
                    ];
                }
                this.completed = true;
            }
        },

        errorSendProcessing(error) {
            let response = error.response;

            this.processing = false;
            this.completed = false;
            this.taskId = null;
            if (response.status == 422 && response.data && response.data.errors && response.data.errors.recaptcha_response) {
                this.sendError = response.data.errors.recaptcha_response[0];
                this.sendErrorCode = 422;
            } else {
                this.sendError = (response.data.message) ? response.data.message : this.trans('tool-main.Unable process file'); // todo need show error message
                this.sendErrorCode = (response.data.error_code) ? response.data.error_code : null; // need for logic showing errors
            }
        },

        canceledSendProcessing() {
            this.processing = false;
            this.completed = false;
            this.taskId = null;
        },

        cancelSendTask() {
            this.beforeCancel();

            this.sended = false;
            this.completed = false;
            this.sendError = null;
            this.sendErrorCode = null;

            if (this.cancelToken) {
                this.cancelToken.cancel(this.trans('tool-main.Operation canceled'));
                this.cancelToken = null;
            }

            if (this.processing) {
                // todo need make cancel on server task
                clearInterval(this.interval);
                this.processing = false;
                this.progress = null;
                this.state = null;
                this.interval = null;
                this.taskId = null;
            } else {
                this.taskId = null;
            }

            this.afterCancel();
        },

        reset() {
            this.beforeReset();

            this.sended = false;
            this.completed = false;
            this.processing = false;
            this.progress = null;
            this.state = null;
            this.sendError = null;
            this.sendErrorCode = null;
            this.cancelToken = null;
            this.taskId = null;

            this.afterReset();
        },

        startCheckingProcessing() {
            clearInterval(this.interval);
            let intervalDuration = 10000;

            if ((typeof window.stripe !== "undefined") && parseInt(window.stripe.ha)) {
                intervalDuration = 3000;
            }
            this.interval = setInterval(() => {
                this._checkProcessingRequest();
            }, intervalDuration)
            this._checkProcessingRequest();
        },

        _checkProcessingRequest() {
            if (this.taskId === null) {
                this.errorProcessing({
                    'response' : {
                        'message': 'taskId is null',
                    }
                });
            } else {
                axios({
                    method: 'POST',
                    url   : '/task/progress/' + this.taskId,
                    data  : {},
                }).then(response => {
                    this._successProcessingActions(response);
                }).catch(error => {
                    let response = error.response;
                    if ([504, 520, 524].indexOf(response.status) === -1) { // exclude error timeout, more likely for dev cluster
                        this.errorProcessing(error);
                    }
                });
            }
        },
        _successProcessingActions(response) {
            this.onBeforeSuccessProcessing(response);
            this.successProcessing(response);
            this.onAfterSuccessProcessing(response);
        },
        onBeforeSuccessProcessing(response) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        onAfterSuccessProcessing(response) {
            // you should override this if needed
            // not use for processing, only additional changes state of component
        },

        successProcessing(response) {
            let result = response.data;

            this.state = result.state;
            this.progress = result.progress;

            if (this.state === 'completed') {
                clearInterval(this.interval);
                this.processing = false;
                this.completed = true;

                this.downloadUrl = result.download_url;
                this.images = result.images;
                this.downloadFiles = result.files;
                this.downloadFileInfo.name = result.download_url.replace(/^.*[\\\/]/, '');
                this.dropboxFiles = [
                    {
                        'url'     : result.download_url,
                        'filename': result.download_url.replace(/^.*[\\\/]/, ''),
                        'task_id' : this.taskId,
                    }
                ];
            }
        },

        beforeErrorProcessing(error) {
            // you should override this if needed
        },

        errorProcessing(error) {
            this.beforeErrorProcessing(error);
            let response = error.response;

            clearInterval(this.interval);
            this.processing = false;
            this.completed = false;
            this.taskId = null;
            this.progress = null;
            this.state = null;
            this.sendError = (response.message) ? response.message : (response.data.message ? response.data.message : this.trans('tool-main.Unable process file')); // todo need show error message
            this.sendErrorCode = (response.error_code) ? response.error_code : (response.data.error_code ? response.data.error_code : null); // need for logic showing errors

            this.afterErrorProcessing(error);
        },

        afterErrorProcessing(error) {
            // you should override this if needed
        },

        beforeReset() {
            // you should override this if needed
        },

        afterReset() {
            // you should override this if needed
        },

        afterCancel() {
            // you should override this if needed
        },

        beforeCancel() {
            // you should override this if needed
        },

        onCancelDropbox() {
            console.log('onCancelDropbox');
        },
        onErrorDropbox(errorMessage) {
            console.log('onErrorDropbox');
            console.log(errorMessage);
        },
        onProgressDropbox(progress) {
            console.log('onProgressDropbox');
            console.log(progress);
        },
        onSavedDropbox() {
            console.log('onSavedDropbox');
        },

        // used for tools without file uploaded, only for small text files
        getSelectedFileContent() {
            let muFileSelectedCookie = cookie.parse(document.cookie)['my-file-selected[' + this.loaderType + '_' + this.loaderMode + ']'];
            if ((muFileSelectedCookie !== undefined) && (window.location.hash === '#selected')) {

                let fileData = muFileSelectedCookie.split('---');
                return axios({
                    method: 'POST',
                    url   : '/files/select-content',
                    data  : {
                        type: this.loaderType,
                        mode: this.loaderMode,
                        file: {
                            id: fileData[0],
                        },
                    },
                }).then(response => {
                    if (response.data.status) {
                        let date = new Date(0).toUTCString();
                        document.cookie = "my-file-selected[" + this.type + "_" + this.mode + "]=; expires=" + date + ";path=/";

                        return response.data.content;
                    } else {
                        return false;
                    }
                }).catch(error => {
                    let response = error.response;
                    console.error('select file load error');
                    console.error(response);

                    return false;
                });
            }

            return false;
        },
        // used for complex tools from chatbot
        getSelectedFile() {
            let fileUploadCookie = cookie.parse(document.cookie)['file-upload[' + this.loaderType + '_' + this.loaderMode + ']'];
            if ((typeof fileUploadCookie !== "undefined") && (window.location.hash === '#upload')) {

                let fileData = fileUploadCookie.split('---');
                this.updateFiles([{
                    'file_id': fileData[0],
                    'url'    : fileData[1],
                }]);
            }

            return false;
        },
    },
}
